export const ServiceStatusEnum = {
  Option: 'Option',
  OnRequest: 'On Request',
  RequestConfirmation: 'Request Confirmation',
  Confirmed: 'Confirmed',
  Waitlisted: 'Waitlisted',
  Expired: 'Expired',
  RequestCancellation: 'Request Cancellation',
  Cancelled: 'Cancelled'
}; 